import { path } from 'ramda';
import { Transaction, TransactionItem } from '../../model';

export function getCurrentItem(transaction: Transaction, currentIndex: number) {
  return path<TransactionItem>(['items', currentIndex], transaction);
}

// Validate the code was really dead!
